import { create } from 'zustand';

export type ScanSetAsideSession = {
  operationId: string;
  indexed: number;
  setAside: number;
  unchanged: number;
  completedAt: number;
};

type ScanSetAsideUIState = {
  session: ScanSetAsideSession | null;
  dismissed: boolean;
  reportOpen: boolean;
  setSessionFromScanComplete: (session: ScanSetAsideSession) => void;
  clearSession: () => void;
  openReport: () => void;
  closeReport: () => void;
  dismissReport: () => void;
};

export const useScanSetAsideUIStore = create<ScanSetAsideUIState>((set) => ({
  session: null,
  dismissed: false,
  reportOpen: false,

  setSessionFromScanComplete: (session) => {
    if (session.setAside <= 0) {
      set({ session: null, dismissed: false, reportOpen: false });
      return;
    }
    set({ session, dismissed: false, reportOpen: false });
  },

  clearSession: () => set({ session: null, dismissed: false, reportOpen: false }),

  openReport: () => set({ reportOpen: true }),

  closeReport: () => set({ reportOpen: false }),

  dismissReport: () => set({ dismissed: true, reportOpen: false }),
}));
